function encodeImageUrl(url) {
    if (!url) return "";
    try {
        if (typeof url === "string" && url.startsWith("[")) {
            url = JSON.parse(url)[0];
        }
        return encodeURI(url);
    } catch (e) {
        console.error("Image parse error:", e);
        return "";
    }
}

// Function to generate SEO-friendly slug
function generateSlug(name) {
    return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}

export const RenderOpenCall = (categoryName, openCallsList, campaign = "template") => (
    <div style={{ marginTop: '24px', textAlign: 'center', fontFamily: 'Arial, Helvetica, sans-serif' }}>
        {/* Category Header */}
        <h2 style={{ color: '#1A202C', fontSize: '20px', fontWeight: 'bold', margin: '0 0 6px 0', letterSpacing: '-0.3px' }}>
            {categoryName}
        </h2>
        <div style={{ width: '40px', height: '3px', backgroundColor: '#E53E3E', margin: '0 auto 18px auto', fontSize: '0', lineHeight: '0' }}>&nbsp;</div>

        {/* List Container */}
        <table width="100%" cellPadding="0" cellSpacing="0" border="0" style={{ margin: '0 auto', maxWidth: "600px", width: "100%" }}>
            <tbody>
                {openCallsList.map(call => {
                    const isFree = call.fee_type && call.fee_type.toLowerCase() === 'free';
                    const listingUrl =
                        `https://opencallforartists.com/listing/${call.id}-${generateSlug(call.title)}` +
                        `?utm_source=email` +
                        `&utm_medium=user_email_marketing` +
                        `&utm_campaign=${campaign}` +
                        `&utm_content=submit_now`;
                    return (
                        <tr key={call.id}>
                            <td style={{ width: '100%', verticalAlign: 'top', paddingBottom: '16px' }}>
                                <a href={listingUrl} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>

                                    {/* Card Container */}
                                    <table cellPadding="0" cellSpacing="0" width="100%" style={{ borderCollapse: 'collapse', backgroundColor: '#ffffff', borderRadius: '12px', border: '1px solid #E9EDF2', boxShadow: '0 2px 8px rgba(26, 32, 44, 0.06)', overflow: 'hidden' }}>
                                        <tbody>

                                            {/* Timer Banner - slim */}
                                            {call.timer && (
                                                <tr>
                                                    <td style={{ backgroundColor: '#FFF5F5', padding: '6px 14px', textAlign: 'center' }}>
                                                        <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#C53030', letterSpacing: '0.4px', textTransform: 'uppercase' }}>
                                                            ⏳ {call.timer}
                                                        </span>
                                                    </td>
                                                </tr>
                                            )}

                                            {/* Image */}
                                            <tr>
                                                <td>
                                                    <img
                                                        src={encodeImageUrl(call.images)}
                                                        alt={call.title}
                                                        style={{ width: '100%', height: 'auto', maxHeight: '170px', objectFit: 'cover', display: 'block' }}
                                                    />
                                                </td>
                                            </tr>

                                            {/* Content Area */}
                                            <tr>
                                                <td style={{ padding: '14px 16px 16px 16px' }}>
                                                    {/* Left Aligned Content */}
                                                    <div style={{ textAlign: 'left' }}>

                                                        {call.organization_title && (
                                                            <p style={{ fontSize: '11px', fontWeight: 'bold', color: '#A0AEC0', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 4px 0' }}>
                                                                {call.organization_title}
                                                            </p>
                                                        )}

                                                        <h3 style={{ fontSize: '17px', fontWeight: 'bold', color: '#1A202C', margin: '0 0 8px 0', lineHeight: '1.3' }}>
                                                            {call.title}
                                                        </h3>

                                                        {/* Tags */}
                                                        {(call.eligibility || call.city || call.country) && (
                                                            <div style={{ marginBottom: '10px' }}>
                                                                {call.eligibility && (
                                                                    <span style={{ display: 'inline-block', backgroundColor: '#F7FAFC', borderRadius: '6px', padding: '4px 9px', fontSize: '11px', color: '#4A5568', margin: '0 6px 6px 0' }}>
                                                                        {call.eligibility}
                                                                    </span>
                                                                )}
                                                                {(call.city || call.country) && (
                                                                    <span style={{ display: 'inline-block', backgroundColor: '#F7FAFC', borderRadius: '6px', padding: '4px 9px', fontSize: '11px', color: '#4A5568', margin: '0 6px 6px 0' }}>
                                                                        📍 {call.city}{call.city && call.country ? ', ' : ''}{call.country}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Thin divider */}
                                                    <div style={{ borderTop: '1px solid #EDF0F4', margin: '0 0 12px 0', fontSize: '0', lineHeight: '0' }}>&nbsp;</div>

                                                    {/* Footer Grid: Price/Views left, Button right */}
                                                    <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                                        <tbody>
                                                            <tr>
                                                                {/* Left Column: Price & Views */}
                                                                <td align="left" style={{ verticalAlign: 'middle', width: '50%' }}>
                                                                    <div style={{ lineHeight: '1.35' }}>
                                                                        {isFree ? (
                                                                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#38A169' }}>FREE</span>
                                                                        ) : (
                                                                            <>
                                                                                <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#1A202C' }}>${call.price}</span>
                                                                                <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#DD6B20', textTransform: 'uppercase', marginLeft: '5px' }}>{call.fee_type}</span>
                                                                            </>
                                                                        )}
                                                                        <br />
                                                                        <span style={{ fontSize: '12px', color: '#A0AEC0' }}>👁 {call.viewed || 0} views</span>
                                                                    </div>
                                                                </td>

                                                                {/* Right Column: Button */}
                                                                <td align="right" style={{ verticalAlign: 'middle', width: '50%' }}>
                                                                    <table cellPadding="0" cellSpacing="0" border="0" style={{ display: 'inline-block' }}>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td align="center" style={{ backgroundColor: '#E53E3E', borderRadius: '8px' }}>
                                                                                    <a href={listingUrl} style={{ color: '#FFFFFF', fontSize: '13px', fontWeight: 'bold', textDecoration: 'none', display: 'block', padding: '9px 16px' }}>
                                                                                        Submit Now &rarr;
                                                                                    </a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </a>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    </div>
);

export const RenderFeaturedOpenCall = (openCall, campaign = "template_featured_open_call") => {
    const isFree = openCall.fee_type && openCall.fee_type.toLowerCase() === 'free';
    const listingUrl = `https://opencallforartists.com/listing/${openCall.id}-${generateSlug(openCall.title)}` + `?utm_source=email` + `&utm_medium=user_email_marketing` + `&utm_campaign=${campaign}` + `&utm_content=submit_now`;
    return (
        <div style={{ marginTop: '24px', textAlign: 'center', fontFamily: 'Arial, Helvetica, sans-serif' }}>
            {/* Category Header */}
            <h2 style={{ color: '#1A202C', fontSize: '20px', fontWeight: 'bold', margin: '0 0 6px 0', letterSpacing: '-0.3px' }}>
                {openCall.category}
            </h2>
            <div style={{ width: '40px', height: '3px', backgroundColor: '#E53E3E', margin: '0 auto 18px auto', fontSize: '0', lineHeight: '0' }}>&nbsp;</div>

            {/* List Container */}
            <table width="100%" cellPadding="0" cellSpacing="0" border="0" style={{ margin: '0 auto', maxWidth: "600px", width: "100%" }}>
                <tbody>
                    <tr key={openCall.id}>
                        <td style={{ width: '100%', verticalAlign: 'top', paddingBottom: '16px' }}>
                            <a href={listingUrl} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>

                                {/* Card Container - featured gets a warm accent border */}
                                <table cellPadding="0" cellSpacing="0" width="100%" style={{ borderCollapse: 'collapse', backgroundColor: '#ffffff', borderRadius: '12px', border: '1.5px solid #F6C453', boxShadow: '0 4px 14px rgba(221, 107, 32, 0.14)', overflow: 'hidden' }}>
                                    <tbody>

                                        {/* Featured + Timer Banner */}
                                        <tr>
                                            <td style={{ backgroundColor: '#FFFBEB', padding: '6px 14px', textAlign: 'center' }}>
                                                <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#92400E', letterSpacing: '0.4px', textTransform: 'uppercase' }}>
                                                    ⭐ Featured{openCall.timer ? `  ·  ⏳ ${openCall.timer}` : ''}
                                                </span>
                                            </td>
                                        </tr>

                                        {/* Image */}
                                        <tr>
                                            <td>
                                                <img
                                                    src={encodeImageUrl(openCall.images)}
                                                    alt={openCall.title}
                                                    style={{ width: '100%', height: 'auto', maxHeight: '190px', objectFit: 'cover', display: 'block' }}
                                                />
                                            </td>
                                        </tr>

                                        {/* Content Area */}
                                        <tr>
                                            <td style={{ padding: '16px' }}>
                                                {/* Left Aligned Content */}
                                                <div style={{ textAlign: 'left' }}>

                                                    {openCall.organization_title && (
                                                        <p style={{ fontSize: '11px', fontWeight: 'bold', color: '#A0AEC0', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 4px 0' }}>
                                                            {openCall.organization_title}
                                                        </p>
                                                    )}

                                                    <h3 style={{ fontSize: '19px', fontWeight: 'bold', color: '#1A202C', margin: '0 0 8px 0', lineHeight: '1.3' }}>
                                                        {openCall.title}
                                                    </h3>

                                                    {/* Tags */}
                                                    {(openCall.eligibility || openCall.deadline || openCall.city || openCall.country) && (
                                                        <div style={{ marginBottom: '10px' }}>
                                                            {openCall.eligibility && (
                                                                <span style={{ display: 'inline-block', backgroundColor: '#F7FAFC', borderRadius: '6px', padding: '4px 9px', fontSize: '11px', color: '#4A5568', margin: '0 6px 6px 0' }}>
                                                                    {openCall.eligibility}
                                                                </span>
                                                            )}
                                                            {openCall.deadline && (
                                                                <span style={{ display: 'inline-block', backgroundColor: '#FFFBEB', borderRadius: '6px', padding: '4px 9px', fontSize: '11px', color: '#92400E', margin: '0 6px 6px 0' }}>
                                                                    Deadline: {new Date(openCall.deadline).toLocaleDateString()}
                                                                </span>
                                                            )}
                                                            {(openCall.city || openCall.country) && (
                                                                <span style={{ display: 'inline-block', backgroundColor: '#F7FAFC', borderRadius: '6px', padding: '4px 9px', fontSize: '11px', color: '#4A5568', margin: '0 6px 6px 0' }}>
                                                                    📍 {openCall.city}{openCall.city && openCall.country ? ', ' : ''}{openCall.country}
                                                                </span>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Thin divider */}
                                                <div style={{ borderTop: '1px solid #EDF0F4', margin: '0 0 12px 0', fontSize: '0', lineHeight: '0' }}>&nbsp;</div>

                                                {/* Footer Grid: Price/Views left, Button right */}
                                                <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                                    <tbody>
                                                        <tr>
                                                            <td align="left" style={{ verticalAlign: 'middle', width: '50%' }}>
                                                                <div style={{ lineHeight: '1.35' }}>
                                                                    {isFree ? (
                                                                        <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#38A169' }}>FREE</span>
                                                                    ) : (
                                                                        <>
                                                                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#1A202C' }}>${openCall.price}</span>
                                                                            <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#DD6B20', textTransform: 'uppercase', marginLeft: '5px' }}>{openCall.fee_type}</span>
                                                                        </>
                                                                    )}
                                                                    <br />
                                                                    <span style={{ fontSize: '12px', color: '#A0AEC0' }}>👁 {openCall.viewed || 0} views</span>
                                                                </div>
                                                            </td>
                                                            <td align="right" style={{ verticalAlign: 'middle', width: '50%' }}>
                                                                <table cellPadding="0" cellSpacing="0" border="0" style={{ display: 'inline-block' }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td align="center" style={{ backgroundColor: '#E53E3E', borderRadius: '8px' }}>
                                                                                <a href={listingUrl} style={{ color: '#FFFFFF', fontSize: '13px', fontWeight: 'bold', textDecoration: 'none', display: 'block', padding: '9px 18px' }}>
                                                                                    Submit Now &rarr;
                                                                                </a>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export const RenderArtistOfTheMonth = (categoryName, artistOfTheMonth) => (
    <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <h2 style={{ color: '#000000', fontSize: '24px', fontWeight: 'bold' }}>{categoryName}</h2>
        <table width="100%" cellPadding="10" cellSpacing="0" border="0" style={{ tableLayout: 'fixed', margin: '0 auto', maxWidth: "800px", width: "100%" }}>
            <tbody>
                {artistOfTheMonth.map(artistMonth => (
                    <tr key={artistMonth.id}>
                        <td style={{ width: '100%', verticalAlign: 'top' }}>
                            <a href={`https://opencallforartists.com/users/user/${artistMonth.user_id}-${generateSlug(`${artistMonth.first_name} ${artistMonth.last_name}`)}`} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
                                <table cellPadding="0" cellSpacing="0" style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#ffffff', borderRadius: '8px', boxShadow: '0 1px 5px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <img src={encodeImageUrl(artistMonth.featured_image)} alt={artistMonth.title} style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '8px 8px 0 0' }} />
                                                <div style={{ padding: '16px' }}>
                                                    <p style={{ fontSize: '14px', color: '#4A5568', marginBottom: '8px' }}>
                                                        <strong>{artistMonth.first_name} {artistMonth.last_name}</strong><br />
                                                        {artistMonth.country}<br />
                                                    </p>
                                                    <table width="100%" cellPadding="0" cellSpacing="0">
                                                        <tbody>
                                                            <tr>
                                                                {/* Left: Views */}
                                                                <td style={{ verticalAlign: 'middle', textAlign: "left", width: '5%' }}>
                                                                    <table cellPadding="0" cellSpacing="0" style={{ display: 'inline-block' }}>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td style={{ color: '#FFFFFF', verticalAlign: 'middle', backgroundColor: '#000000', padding: '2px 2px', borderRadius: '10px' }}>
                                                                                    <span style={{ fontSize: '14px', padding: '10px' }}>{new Date(0, artistMonth.month - 1).toLocaleString('en-US', { month: 'long' })}</span>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: "right", width: '5%' }}>
                                                                    <table cellPadding="0" cellSpacing="0" style={{ display: 'inline-block' }}>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td style={{ color: '#FFFFFF', verticalAlign: 'middle', backgroundColor: '#000000', padding: '2px 2px', borderRadius: '10px' }}>
                                                                                    <span style={{ fontSize: '14px', padding: '10px' }}>{artistMonth.year}</span>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </a>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);